import { ArrowDownIcon } from '@heroicons/react/24/solid'
import { cn } from '../../lib/utils'

export interface JumpToLatestProps {
  /** Whether content has arrived below the fold since the user scrolled away. */
  visible: boolean
  onClick: () => void
  className?: string
}

/**
 * Affordance offered on a streaming surface once the user has scrolled away
 * from the bottom and new content has arrived without them (DEV-595). Position
 * it inside a `relative` wrapper around the scroll container, not inside the
 * container itself, or it scrolls away with the content.
 */
const JumpToLatest = ({ visible, onClick, className }: JumpToLatestProps) => (
  <button
    type="button"
    onClick={onClick}
    aria-hidden={!visible}
    tabIndex={visible ? 0 : -1}
    className={cn(
      'absolute bottom-4 left-1/2 z-10 inline-flex -translate-x-1/2 items-center gap-1.5',
      'rounded-full border border-border bg-background/95 px-3 py-1.5 text-xs font-medium',
      'text-foreground shadow-md backdrop-blur transition-all duration-150',
      'hover:bg-accent hover:text-accent-foreground',
      'focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50',
      visible
        ? 'translate-y-0 opacity-100'
        : 'pointer-events-none translate-y-1 opacity-0',
      className,
    )}
  >
    <ArrowDownIcon className="h-3.5 w-3.5" />
    Jump to latest
  </button>
)

export default JumpToLatest
